import './Bingo.scss';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api from '../../../../js/api';
import { useContext, useEffect, useState } from 'react';
import Modal from '../../../../components/Modal/Modal';
import Board from './Board';
import { UserContext } from '../../../../js/UserContext';
import Button from '../../../../components/Button/Button';
import { hasRole } from '../../../../js/utils';

export default function Bingo() {

    const s_params = useSearchParams();
    const { roomNumber } = useParams();
    const navigate = useNavigate();
    const [room, setRoom] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const { user, loading } = useContext(UserContext);

    const login_spy = s_params[0].get('login');


    const start = async () => {
        const res = await api.get(`/rooms/${roomNumber}`, { silent: true })
        if (res && res.error) {
            console.error('Error fetching room data:', res.error);
            alert(res.error ? res.error : 'An error occurred while fetching the room data.');
            navigate('/misc/minigames/bingo', { replace: true });
            return;
        }

        if (!res || !res.id || !res.users) {
            console.error('Invalid room data:', res);
            alert('Invalid room data. Please try again later.');
            navigate('/misc/minigames/bingo', { replace: true });
            return;
        }

        if (!res.users.includes(user.login)) {
            const confirmJoin = window.confirm(`You are not in this room. Do you want to join?`);
            if (!confirmJoin) {
                navigate('/misc/minigames/bingo', { replace: true });
                return;
            }

            let password = '';
            if (res.is_private) {
                password = prompt('This room is private. Please enter the password to join:', '');
                if (!password) {
                    alert('You must enter a password to join this room.');
                    navigate('/misc/minigames/bingo', { replace: true });
                    return;
                }
            }

            // If user is not in the room, add them
            const joinRes = await api.post(`/users/${user.login}/rooms/${roomNumber}`, {
                password: password || '',
            }, { silent: true });
            if (joinRes && joinRes.error) {
                console.error('Error joining room:', joinRes.error);
                alert(joinRes.error ? joinRes.error : 'An error occurred while joining the room.');
                navigate('/misc/minigames/bingo', { replace: true });
                return;
            }
            console.log('Successfully joined the room:', joinRes);
            // Successfully joined the room, update the room state
        }
        if (res && res.admin && user && user.login) {
            setIsAdmin(res.admin === user.login || hasRole(user, 'root'));
        }
        return res;
    }

    useEffect(() => {
        if (!roomNumber) {
            navigate('/misc/minigames/bingo', { replace: true });
            return;
        }
        start().then((res) => {
            if (res) {
                setRoom(res);
            } else {
                console.error('No room data returned');
            }
        }).catch((error) => {
            console.error('Error starting Bingo:', error);
            alert('An error occurred while starting the Bingo game.');
            navigate('/misc/minigames/bingo', { replace: true });
        });
    }, []);

    if (!room) {
        return <p>Loading room data...</p>;
    }
    if (loading) {
        return <p>Loading user data...</p>;
    }

    const buttons = {
        room_details:
            room ? (
                <Modal text="Room Details">
                    <p>Admin: {room.admin}</p>
                    <br />
                    <p>Private: {room.is_private ? 'Yes' : 'No'}</p>
                    <br />
                    {room.password && <p>Password: {room.password}</p>}
                </Modal>
            ) : (
                <p>Loading room data...</p>
            ),
        users:
            room ? (
                <Modal text="Users">
                    <ul className='users-list'>
                        {room.users && room.users.length > 0 ? (
                            room.users.map((user, index) => (
                                <li key={index}>
                                    <a href={`/misc/minigames/bingo/rooms/${room.id}?login=${user}`}>
                                        {user ? user.charAt(0).toUpperCase() + user.slice(1) : null}
                                    </a>
                                </li>
                            ))
                        ) : (
                            <p>No users in this room.</p>
                        )}
                    </ul>
                </Modal>
            ) : (
                <p>Loading room data...</p>
            ),
        delete_room:
            isAdmin ? (
                <Button text="Delete Room" class_="red white-text" onClick={async () => {
                    if (!window.confirm('Are you sure you want to delete this room? This action cannot be undone.')) {
                        return;
                    }
                    try {
                        const r = await api.delete(`/rooms/${room.id}`);
                        if (r && r.error) {
                            console.error('Error deleting room:', r.error);
                            return;
                        }
                        alert('Room deleted successfully.');
                        navigate('/misc/minigames/bingo', { replace: true });
                    } catch (error) {
                        console.error('Error deleting room:', error);
                        alert('An error occurred while deleting the room.');
                    }
                }} />
            ) : null,
        room_stats:
            <Modal text="Hola" fn={async () => {
                
                return (
                    <>
                        <p>Esto no hace nada no me ha dado timepo a acabar</p>
                        <br />
                        <p>Debería mostrar las stats, pero bueno, se las puedes preguntar a tus amigos</p>
                        <br />
                        <p>jeje</p>
                    </>
                )
            }}>
                <h3>Room stats</h3>
                <br />
            </Modal >,
    }

    const user_spy = s_params[0].get('login');

    const info_container = (
        <div className='info-container flex gap flex-center flex-wrap border border-radius margin'>
            <p className='info'>Viewing room for user: <b>{user_spy}</b></p>
            <Button text="Back to My Room" onClick={() => {
                navigate(`/misc/minigames/bingo/rooms/${room.id}`, { replace: true });
                window.location.reload();
            }} />
        </div>
    )

    return (
        <div id='bingo'>
            <div className='centered-container'>
                <h3 className='title'>{`Room: ${room.name} (code: ${room.id})`}</h3>
                {(user_spy && user_spy !== user.login) ? info_container : null}
                <div className='flex gap flex-wrap flex-center'>
                    {buttons.room_details}
                    {buttons.users}
                    {buttons.stats}
                    {buttons.delete_room}
                    {buttons.room_stats}
                </div>

                {room ? (
                    <Board rows={4} columns={3} room={room} />
                ) : (
                    <p>Loading board...</p>
                )}

            </div>
        </div>
    );
}